<template>
  <div class="container-fluid" style="width: 100%">
    <!-- 第一行 -->
    <div class="container-fluid px-0 mx-0">
      <div class="row bg-about-image-container h-100 w-100 no-gutters">
        <div class="col-12 position-relative">
          <img src="../assets/images/about/about-welcome.png" alt="Service Welcome Image" class="img-fluid w-100"/>
          <div class="gradient-overlay position-absolute bottom-0 w-100 h-25"
               style="background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 255, 0.7));"></div>
          <div class="text-container position-absolute bottom-0 w-100 justify-content-center align-items-center">
            <p class="text-left text-white mb-0 pb-0 font-class-ref-title">
              {{ $t('h.about_title') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 第二行 -->
    <div class="container-fluid">
      <div class="row align-items-center mb-5 mt-5">
        <div class="col-12">
          <h2 class="boldText">{{ $t("h.about_us") }}</h2>
        </div>
      </div>
    </div>

    <div class="container-fluid justify-content-center align-items-center mb-6">
      <div class="row align-items-center justify-content-center">
        <div class="col-md-4 align-items-center justify-content-center">
          <!-- 学校介绍部分 -->
          <h2 class=" boldText phone-title">{{ $t("h.talent") }}</h2>
           <br>
          <p class="text-left text-black-50 font-class-ref mb-0">
            {{ $t("h.talentInfo1") }}
          </p>
          <p class="text-left text-black-50 font-class-ref">
            {{ $t("h.talentInfo2") }}
          </p>
        </div>
        <div class="col-md-6 schools-container card pt-3">
          <div class="row align-items-center justify-content-center">
            <!-- 第一行学校 -->
            <div v-for="(school, index) in firstRowSchools" :key="index" class="col-md-3 col-sm-6 col-6">
              <img :alt="`School Alt ${index + 1}`" class="schoolimg" 
                   :src="require(`../../public/images/about/icon/${school.imgSrc}.png`)">
              <p class="font-class-ref">{{ school.title }}</p>
            </div>
            <!-- 第二行及后续学校 -->
            <div v-for="(school, index) in secondRowSchools" :key="index + firstRowSchools.length"
                 class="col-md-3 col-sm-6 col-6">
              <img :alt="`School Alt ${index + 1 + firstRowSchools.length}`"
              class="schoolimg" 
                  
                   :src="require(`../../public/images/about/icon/${school.imgSrc}.png`)">
              <p class="font-class-ref">{{ school.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 第三行 -->
    <div class="container mb-5 mt-5">
      <div class="row">
        <div class="col-md-7">
          <img style="    border-radius: 15px;" src="../../public/images/about/abo-3.png" class="w-100">
        </div>
        <div class="col-md-5 mt-3">
          <h2 class="phone-title boldText">{{ $t("h.about_business") }}</h2>
           <br>
          <p class="text-left text-black-50 font-class-ref">
            {{ $t("h.about_businessInfo1") }}
          </p>
          <p class="text-left text-black-50 font-class-ref">
            {{ $t("h.about_businessInfo2") }}
          </p>
        </div>
      </div>
    </div>

    <!-- 第四行 -->
    <div class="container mb-5 mt-5">
      <div class="row">

        <div class="col-md-5">
           <br>
          <h2 class="phone-title boldText">{{ $t("h.about_clients") }}</h2>
           <br>
          <p class="text-left text-black-50 font-class-ref">
            {{ $t("h.about_clientsInfo") }}
          </p>
        </div>
        <div class="col-md-7">
          <img style="    border-radius: 15px;" src="../../public/images/about/abo-4.png" class=" w-100">
        </div>

      </div>
    </div>

     <!-- 第七部分：卡片 -->
    <div style="    margin-top: 5em;    margin-bottom: 5em;"  class="container">
      <div class="row justify-content-center align-items-center mb-4 mt-5">
        <div class="row no-gutters">
          <div class="col-md-12">
            <h3 class="card-title text-center font-weight-bold boldText">{{ $t("h.culture_summery") }}</h3>
             <br>
            <p class="text-left text-black-50 mb-0 font-class-ref ml-5 mr-5">
              {{ $t("h.culture_summery_info1") }}
            </p>
            <p class="text-left text-black-50 mb-3 font-class-ref ml-5 mr-5">
              {{ $t("h.culture_summery_info2") }}
            </p>
             <div class="col-md-12">
            <img  src="../../public/images/culture/cul-7-1.png" class="card-img " alt="Card image" style="height: 100%; border-radius: 15px;">
          </div>
          </div>
         
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {schoolList_zh} from "@/constant/zh/schoolList";

export default {
  name: 'About',
  // 组件的其它部分...
  data() {
    return {
      schoolList: schoolList_zh
    }
  },
  computed: {
    firstRowSchools() {
      return this.schoolList.slice(0, 3).map((school, index) => ({
        ...school,
        imgSrc: school.index,
        title: this.$t(`h.school_title${index + 1}`)
      }));
    },
    secondRowSchools() {
      return this.schoolList.slice(3).map((school, index) => ({
        ...school,
        imgSrc: school.index,
        title: this.$t(`h.school_title${index + 4}`) // 假设索引从1开始，这里需要调整
      }));
    }
  }
}
</script>

<style scoped>

@media (min-width: 1200px) {

    .container-xl, .container-lg, .container-md, .container-sm, .container {
        max-width: 90%;
    }
}


.schools-container{
  border-radius: 1.25rem !important;
}
.boldText{
  font-size: 40px;
    font-weight: 700;
}
.container-fluid {
  padding: 0;
}
.no-gutters{
 
}

.bg-about-image-container {
  /* 确保容器有足够的高度来显示图片和渐变 */
  height: 90vh; /* 或根据您的需求调整 */
  overflow: hidden; /* 防止图片或渐变溢出容器 */
}

.gradient-overlay {
  /* 渐变层覆盖在图片底部 */
  position: absolute;
  bottom: 0;
  left: 0;
  height: 25%; /* 渐变层的高度，您可以根据需要调整 */
  pointer-events: none; /* 防止渐变层影响下方的点击事件 */
}

.text-container {
  /* 文本容器，使用flex布局在渐变层上居中显示文本 */
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: flex-end; /* 垂直居底（因为已经设置了bottom: 0） */
  width: 100%;
  z-index: 1; /* 确保文本在渐变层之上 */
  padding: 0.8rem !important;
}

/*默认字体大小*/
.font-class-ref {
  font-size: 1.5vw
}

.font-class-ref-title {
  padding-right: 3rem;
  padding-left: 3rem;
  font-size: 1.5vw;
}
 .schoolimg{
    width: 7vw;
    height: 7vw;
        border-radius: 50%;
    border: 1px solid #adaaaa;
  }
 .phone-title{
    text-align: left;
  }
@media (max-width: 768px) {
  .schoolimg{
    width: 27vw;
    height: 27vw;
        border-radius: 50%;
    border: 1px solid #adaaaa;
  }
  .font-class-ref {
    font-size: 1.7vw
  }
   .boldText{
    font-size: 30px;
  }
   .phone-title{
    text-align: left;
  }
}


@media (max-width: 567px) {
  .phone-title{
    text-align: center;
  }
  .schoolimg{
    width: 27vw;
    height: 27vw;
        border-radius: 50%;
    border: 1px solid #adaaaa;
  }
  .font-class-ref {
    font-size: 5vw;
    margin: 1em;
  }
   .boldText{
    font-size: 30px;
  }

  .font-class-ref-title {
    padding-right: 0.2rem;
    padding-left: 0.2rem;
    font-size: 3vw;
  }
}

</style>
